/**
 * Helper defensivo para envolver Promesas con un timeout máximo.
 *
 * Si la Promesa NO resuelve en `ms` milisegundos, el wrapper rechaza con un
 * error que incluye el `context` para facilitar debugging. Útil para evitar
 * que llamadas a Firestore con índices faltantes, contención o problemas de
 * red dejen al usuario con un spinner infinito.
 *
 * Uso:
 *   import { withTimeout } from './withTimeout';
 *   try {
 *     const snap = await withTimeout(ref.get(), 15000, 'Cargar carpeta raíz');
 *     // ...
 *   } catch (err) {
 *     if (err.isTimeout) notification.error({...});
 *   }
 */

export const withTimeout = (promise, ms, context = 'operación') => {
  return new Promise((resolve, reject) => {
    const timer = setTimeout(() => {
      const err = new Error(`Timeout (${ms}ms) en: ${context}`);
      err.isTimeout = true;
      err.context = context;
      reject(err);
    }, ms);

    if (!promise || typeof promise.then !== 'function') {
      clearTimeout(timer);
      resolve(promise);
      return;
    }

    promise.then(
      (res) => { clearTimeout(timer); resolve(res); },
      (err) => { clearTimeout(timer); reject(err); }
    );
  });
};

export default withTimeout;
